/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getEnumDecoder,
  getEnumEncoder,
  type FixedSizeCodec,
  type FixedSizeDecoder,
  type FixedSizeEncoder,
} from "@solana/kit";

/** Value types for constraint conditions */
export enum ValueType {
  String,
  Number,
  Boolean,
  Date,
  Time,
  Duration,
  List,
  Object,
}

export type ValueTypeArgs = ValueType;

export function getValueTypeEncoder(): FixedSizeEncoder<ValueTypeArgs> {
  return getEnumEncoder(ValueType);
}

export function getValueTypeDecoder(): FixedSizeDecoder<ValueType> {
  return getEnumDecoder(ValueType);
}

export function getValueTypeCodec(): FixedSizeCodec<ValueTypeArgs, ValueType> {
  return combineCodec(getValueTypeEncoder(), getValueTypeDecoder());
}
